import { render, staticRenderFns } from "./form-new-email.vue?vue&type=template&id=17706bae&scoped=true&lang=pug"
import script from "./form-new-email.vue?vue&type=script&lang=js"
export * from "./form-new-email.vue?vue&type=script&lang=js"
import style0 from "./form-new-email.vue?vue&type=style&index=0&id=17706bae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17706bae",
  null
  
)

export default component.exports